import Vuex from "vuex"
import {forIn} from "lodash"
import Vue from "vue"

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        forms: [],
        data_race: null,
        default_data: null,
        testi_donazione: null,
        id_race: null,
        team: null,
        not_myself: false,
        path_chosen: null,
        payer_id: null,
        donazione: null,
        join_req: null,
        regalo: false,
        history: {},
    },
    mutations: {
        regalo(state,value) {
            state.regalo = value
        },  new_form(state, payload) {
            state.forms.push(Object.assign({}, payload))
        }, race_data(state, race) {
            state.data_race = new Date(race.data)
            state.id_race = race.id
            if (race.team)
                state.join_req = race.team
            state.testi_donazione = race
        }, submit(state, data) {
            state.forms[data.id_form] = data.data
        }, update(state, data) {
            // Verifico se aveva già un id, in questo caso lo mantengo
            let old_id = state.forms[data.id_form]['id']
            if (old_id)
                data.data['id'] = old_id
            Vue.set(state.forms, data.id_form, data.data)
        }, team(state, team) {
            state.team = team
        }, default_data(state, data) {
            state.default_data = data
        }, vue(state, vue) {
            state.$http = vue.$http
            state.$notify = vue.$notify
            state.$cookies = vue.$cookies
        }, id_response(state, data) {
            let form = state.forms[data.id_form]
            form['id'] = data.id
            Vue.set(state.forms, data.id_form, form)
        }, nomyself(state, data) {
            state.not_myself = data
        }, clear_forms(state) {
            state.forms = []
            state.history = {}
            state.not_myself = false
            state.default_data = null
            state.id_team = null
            state.team = null
        }, path_chosen(state, data) {
            state.path_chosen = data
        }, history(state, data) {
            state.history[data.type] = data.data
        }, payer_id(state, id) {
            state.payer_id = id
        }, donazione(state, id) {
            state.donazione = id
        }, del_form(state, data) {
            Vue.delete(state.forms, data.num_form)
        }
    }, actions: {
        regalo(context,value) {
            context.commit('regalo',value)
        },
        race_data(context) {
            // eslint-disable-next-line
            context.commit('race_data', race_data)
        }, submit(context, data) {
            return new Promise((resolve, reject) => {
                    // Aggiungo l'id race a tutte le chiamate
                    let post = data.data

                    post.id_race = context.state.id_race
                    if (context.state.team)
                        post.id_team = context.state.team.id
                    if (context.state[data.id_form] && context.state[data.id_form]['id'])
                        post.id = context.state[data.id_form]['id']

                    // Aggiorno il token, questo è importante perchè dopo una registrazione
                    // faccio il login dell'utente e questo fa sì che il token cambi!
                    context.state.$http.defaults.headers.common['X-CSRFToken'] = context.state.$cookies.get('csrftoken')

                    if (data.retry) {
                        context.state.$http.post(data.url, post, {timeout: 2000})
                            .then(response => {
                                if (response.data.success || response.data.redirect) {
                                    context.commit('submit', {
                                        id_form: data.id_form,
                                        data: data.data
                                    })
                                    if (response.data.id)
                                        context.commit('id_response', {
                                            id_form: data.id_form,
                                            id: response.data.id
                                        })
                                    resolve(response)
                                } else {
                                    let errors = ''
                                    forIn(response.data.errors, (value, key) => {
                                        errors += '<br><strong>' + key + '</strong>: ' + value
                                    })
                                    context.state.$notify({
                                        text: 'Il form presenta i seguenti errori:' + errors,
                                        type: 'warn'
                                    })
                                    reject(response)
                                }
                            }, () => {
                                post.retry = true
                                context.state.$http.post(data.url, post, {timeout: 2000})
                                    .then(response => {
                                        if (response.data.success) {
                                            context.commit('submit', {
                                                id_form: data.id_form,
                                                data: data.data
                                            })
                                            if (response.data.id)
                                                context.commit('id_response', {
                                                    id_form: data.id_form,
                                                    id: response.data.id
                                                })
                                            resolve(response)
                                        } else {
                                            let errors = ''
                                            forIn(response.data.errors, (value, key) => {
                                                errors += '<br><strong>' + key + '</strong>: ' + value
                                            })
                                            context.state.$notify({
                                                text: 'Il form presenta i seguenti errori:' + errors,
                                                type: 'warn'
                                            })
                                            reject(response)
                                        }
                                    }, error => {
                                        context.state.$notify({
                                            text: 'Si è presentato un errore nell\'invio dei dati, riprova più tardi',
                                            type: 'warn'
                                        })
                                        reject(error)
                                    })
                            })
                    } else {
                        context.state.$http.post(data.url, post)
                            .then(response => {
                                if (response.data.success) {
                                    context.commit('submit', {
                                        id_form: data.id_form,
                                        data: data.data
                                    })
                                    if (response.data.id)
                                        context.commit('id_response', {
                                            id_form: data.id_form,
                                            id: response.data.id
                                        })
                                    resolve(response)
                                } else {
                                    let errors = ''
                                    forIn(response.data.errors, (value, key) => {
                                        errors += '<br><strong>' + key + '</strong>: ' + value
                                    })
                                    context.state.$notify({
                                        text: 'Il form presenta i seguenti errori:' + errors,
                                        type: 'warn'
                                    })
                                    reject(response)
                                }
                            }, error => {
                                console.log(error)
                                context.state.$notify({
                                    text: 'Si è presentato un errore nell\'invio dei dati, riprova più tardi',
                                    type: 'warn'
                                })
                                reject(error)
                            })
                    }

                }
            )


        }, update(context, data) {
            context.commit('update', {
                id_form: data.id_form,
                data: Object.assign({}, data.data)
            })
        }, choose_path(context, data) {
            if (context.state.path_chosen === null)
                context.commit('path_chosen', data)
            else if (context.state.path_chosen !== data) {
                context.commit('path_chosen', data)
                context.commit('clear_forms')
            }
        }
    },
    getters: {
        wire_transfer_method: state => {
            return state.forms[0].wire_transfer_method;
        }, get_gold: state => {
            return {is_gold: state.testi_donazione.activate_donazione_gold};
        }, get_gold_amount: state => {
            return {gold_amount: state.testi_donazione.donazione_gold}
        }, get_super_gold_amount: state => {
            return {super_gold_amount: state.testi_donazione.donazione_super_gold}
        }, lastest_form: state => {
            return state.forms.length - 1
        }, next_id_form: state => {
            return state.forms.length
        }, id_team: state => {
            return state.id_team
        }, get_by_id: (state) => (id) => {
            return state.forms[id]
        }, primo_inserimento: state => {
            // Se sto iscrivendo qualcun'altro è come se non fosse il primo inserimento
            if (state.not_myself) return false

            // Altrimenti verifico se ho già inviato un form tipo 'InserimentoDati'
            for (let i = 0; i < state.forms.length; i++)
                if (state.forms[i].id)
                    return false

            return true
        }, default_data: state => {
            return state.default_data
        }, history(state, type) {
            return state.history[type]
        }, donazione_base(state) {
            if (state.testi_donazione !== null)
                return parseInt(state.testi_donazione.base)
            else
                return 0
        }, donazione_maglia(state) {
            if (state.testi_donazione !== null)
                return parseInt(state.testi_donazione.con_maglia)
            else
                return 0
        }, nome_race(state) {
            if (state.testi_donazione === null)
                return ''
            return state.testi_donazione.nome
        }, get_form_by_id: state => id => {
            for (let i = 0; i < state.forms.length; i++)
                if (state.forms[i].id === id)
                    return i
            return false
        }, iscritti: (state, getters) => {
            if (!state.testi_donazione) return []
            let iscritti = []
            let maglia_selection = 0
            let forms = state.forms
            let base = getters.donazione_base
            let maglia = getters.donazione_maglia
            let maglia_num = state.testi_donazione.maglia_num

            for (let i = 0; i < forms.length; i++) {
                let form = forms[i]
                // Ritengo qualcuno 'iscritto' o quantomeno conteggiato nel riassunto
                // Se e solo se ha settato quale è la donazione che intende effettuare
                if (!form.id) continue
                if (form.wire_transfer_method) {
                    form.base = 0
                } else {
                    form.base = base
                }
                if (form.maglia && (maglia_selection % maglia_num === 0)) {
                    form.base += maglia
                }
                if(form.maglia) {
                    maglia_selection += 1
                }

                if (form.don_extra === 'extra') {
                    form.totale = form.base+parseInt(form.don_extra_importo)
                } else {
                    form.totale = form.base+parseInt(form.don_extra)
                }

                form.categoria_show = 'Adulto non competitivo'
                if (form.categoria === 'donna-in-rosa')
                    form.categoria_show = 'Donna in rosa'
                if (form.categoria === 'adulto-competitivo')
                    form.categoria_show = getters.distanza_competitivi
                if (form.categoria === 'donna-in-rosa-competitiva')
                    form.categoria_show = getters.distanza_competitivi + ' Donna in Rosa'
                if (form.categoria === 'bambino')
                    form.categoria_show = 'Bambino'
                iscritti.push(form)
            }
            return iscritti
        }, team(state) {
            return state.team
        }, path_chosen(state) {
            return state.path_chosen
        }, competitivi(state) {
            return state.testi_donazione.competitivi > 0
        }, distanza_competitivi(state) {
            return (state.testi_donazione && state.testi_donazione.distanza_competitivi) || '10 km'
        }, join_request(state)
        {
            return state.join_req
        }, race_logo(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.logo_img
        }, partner_principale(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.principale_img
        }, partner_secondari(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.secondari_img
        }, thanksto(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.thanksto_img
        }, titolo_iniziale(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.titolo_iniziale
        }, sottotitolo_iniziale(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.sottotitolo_iniziale
        }, testo_competitivi(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.testo_competitivi
        }, testo_competitivi_rosa(state) {
            if (!state.testi_donazione)
                return ''
            return state.testi_donazione.testo_competitivi_rosa
        }, con_maglia(state)
        {
            if (!state.testi_donazione) return false
            return state.testi_donazione.maglia_abilitata
        }, maglia_num(state)
        {
            if (!state.testi_donazione) return false
            return state.testi_donazione.maglia_num
        }, testo_maglia(state)
        {
            if (!state.testi_donazione) return ''
            return state.testi_donazione.maglia_testo
        }, titolo_maglia(state)
        {
            if (!state.testi_donazione) return ''
            return state.testi_donazione.maglia_titolo
        }, img_maglia(state)
        {
            if (!state.testi_donazione) return ''
            return state.testi_donazione.maglia_img
        }, maglia(state)
        {
            let hasMaglia = false
            let maglia = {}
            let forms = state.forms
            for (let i = 0; i < forms.length; i++) {
                let form = forms[i]
                // Ritengo qualcuno 'iscritto' o quantomeno conteggiato nel riassunto
                // Se e solo se ha settato quale è la donazione che intende effettuare
                if (!form.id) continue

                if (form.maglia)
                {
                    hasMaglia = true
                    if (form.maglia_nome && !maglia.nome)
                    {
                        maglia.nome = form.maglia_nome
                        maglia.cognome =form. maglia_cognome
                        maglia.cellulare = form.maglia_cellulare
                        maglia.indirizzo = form.maglia_indirizzo
                        maglia.cap = form.maglia_cap
                        maglia.citta = form.maglia_citta
                        maglia.provincia = form.maglia_provincia
                    }
                }
            }
            if (!hasMaglia) return false
            return maglia
        }, imposta_maglia: state => id =>
        {

            let forms = state.forms
            for (let i = 0; i < forms.length; i++) {
                let form = forms[i]
                // Ritengo qualcuno 'iscritto' o quantomeno conteggiato nel riassunto
                // Se e solo se ha settato quale è la donazione che intende effettuare
                if (!form.id) continue

                // Se ho un id, ed è uguale a quello dell'iscritto che sto guardando, questo iscritto ha la maglia abilitata, allora
                // dato che l'ho impostata io per la prima volta, posso modificarlo
                if (id && form.id === id && form.maglia)
                    return true

                // Se sono arrivato fino a qui e qualcuno ha già impostato la maglia, non ha senso che la reimposti io
                if (form.maglia)
                    return false
            }

            // Se sono arrivato fino a qui non ho trovato nessuno con la maglia abilita, posso essere io il primo a farlo
            return true
        }, race_italia(state) {
            if (!state.testi_donazione) return false
            return state.testi_donazione.race_italia > 0
        }, scaglione_maglia: state => id => {
            if (!state.testi_donazione) return false

            let count = 0
            let forms = state.forms
            for (let i = 0; i < forms.length; i++) {
                let form = forms[i]
                // Ritengo qualcuno 'iscritto' o quantomeno conteggiato nel riassunto
                // Se e solo se ha settato quale è la donazione che intende effettuare
                if (!form.id) continue



                // Se è il form "in oggetto", verifico se è arrivato al multiplo di maglie che genera il costo aggiuntivo
                // Es: sono alla maglia 4, 4%5 = 4, non devo fare nulla
                // Ho già scelto 5 maglie, quindi se h
                if (id && form.id === id)
                    return (count % state.testi_donazione.maglia_num) === 0

                                // Se qualcuno ha scelto la maglia, lo conteggio
                if (form.maglia) count += 1
            }

            return (count % state.testi_donazione.maglia_num) === 0
        }, totale_maglie: state => {
            let count = 0
            let forms = state.forms
            for (let i = 0; i < forms.length; i++) {
                let form = forms[i]
                // Ritengo qualcuno 'iscritto' o quantomeno conteggiato nel riassunto
                // Se e solo se ha settato quale è la donazione che intende effettuare
                if (!form.id) continue

                // Se qualcuno ha scelto la maglia, lo conteggio
                if (form.maglia) count += 1
            }
            return count
        }, is_regalo: state => {
            return state.regalo
        }
    }
})